import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { ApiService } from '../../../../utils/services/api.service';
import { AnnouncementFeedback, formatAnnouncementDate, formatTimestampDate } from '../whats-new';

type FeedbackFilter = 'all' | 'Yes' | 'No' | 'notes';

@Component({
  selector: 'app-whats-new-feedbacks',
  templateUrl: './whats-new-feedbacks.component.html',
  styleUrls: ['./whats-new-feedbacks.component.css']
})
export class WhatsNewFeedbacksComponent implements OnInit {
  public announcement: { id: number; title: string; version: string; publishDate: string } = null;
  public feedbacks: AnnouncementFeedback[] = [];
  public filter: FeedbackFilter = 'all';
  public filters: { value: FeedbackFilter; label: string }[] = [
    { value: 'all', label: 'Tümü' },
    { value: 'Yes', label: 'Evet' },
    { value: 'No', label: 'Hayır' },
    { value: 'notes', label: 'Yalnız not bırakanlar' }
  ];
  public formatDate = formatAnnouncementDate;

  constructor(
    private apiService: ApiService,
    private notifications: NotificationsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  get total(): number {
    return this.feedbacks.length;
  }

  get yes(): number {
    return this.feedbacks.filter(feedback => feedback.vote === 'Yes').length;
  }

  get no(): number {
    return this.total - this.yes;
  }

  get notes(): number {
    return this.feedbacks.filter(feedback => feedback.note).length;
  }

  get yesPercent(): number {
    return this.total ? Math.round(this.yes * 100 / this.total) : 0;
  }

  get noPercent(): number {
    return this.total ? 100 - this.yesPercent : 0;
  }

  get rows(): AnnouncementFeedback[] {
    if (this.filter === 'notes') {
      return this.feedbacks.filter(feedback => feedback.note);
    }
    return this.filter === 'all' ? this.feedbacks : this.feedbacks.filter(feedback => feedback.vote === this.filter);
  }

  ngOnInit() {
    const id = Number(this.route.snapshot.params.id);
    this.apiService.getAnnouncementFeedbacks(id).subscribe(res => {
      this.announcement = res.data.announcement;
      this.feedbacks = res.data.feedbacks;
    }, () => {
      this.notifications.error('Hata', 'Geri bildirimler yüklenemedi.');
      this.router.navigate(['/whats-new']);
    });
  }

  feedbackDate(feedback: AnnouncementFeedback): string {
    return formatTimestampDate(feedback.updatedAt);
  }

  userName(feedback: AnnouncementFeedback): string {
    return [feedback.firstName, feedback.lastName].filter(part => part).join(' ') || '—';
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/whats-new/whats-new-feedbacks/whats-new-feedbacks.component.ts